<div [ngSwitch]="branchStockInfo[0].stockStatus.code">
  <span *ngSwitchCase="'Y'" class="badge badge-av d-inline-flex align-items-center">
    Available <span class="badge inner-badge ml-2">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
  <span *ngSwitchCase="'N'" class="badge badge-na d-inline-flex align-items-center">
    Not Available <span class="badge inner-badge ml-2">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
  <span *ngSwitchCase="'Z'" class="badge badge-td d-inline-flex align-items-center">
    Turned Down <span class="badge inner-badge ml-2">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
  <span *ngSwitchCase="'S'" class="badge badge-ss d-inline-flex align-items-center">
    Superseded <span class="badge inner-badge ml-2">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
  <span *ngSwitchCase="'D'" class="badge badge-dd d-inline-flex align-items-center">
    Depot Denied <span class="badge inner-badge ml-2">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
  <span *ngSwitchCase="'F'" class="badge badge-fr d-inline-flex align-items-center">
    Frozen <span class="badge inner-badge ml-2">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
  <span *ngSwitchDefault class="badge badge-def p-0">
    <span class="badge inner-badge">{{ branchStockInfo[0].quantityAvailable }}</span>
  </span>
</div>
